/* @ngInject */
const train = (
  trainNew,
  trainAsk,
  trainGo,
  trainLocal,
  trainData,
  trainFormat,
  trainMetadata,
  trainRequest
) => {
  const self = {}

  self.new = trainNew
  self.go = trainGo
  self.local = trainLocal
  self.format = trainFormat
  self.metadata = trainMetadata
  self.data = trainData
  self.ask = trainAsk
  self.request = trainRequest

  return self
}

export default train



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/services/train.service.js